import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';
import { Position, Queue } from './types';
import { AppState } from './index';
import { loadQueue, setQueueOpen, clearQueue } from './api';

const queuesAdapter = createEntityAdapter<Queue>();

export const queues = createSlice({
  name: 'queues',
  initialState: queuesAdapter.getInitialState(),
  reducers: {},
  extraReducers: {
    [loadQueue.fulfilled.type]: (state, action) => {
      queuesAdapter.upsertMany(state, action.payload.queues);
    },
    [setQueueOpen.pending.type]: (state, action) => {
      queuesAdapter.updateOne(state, {
        id: action.meta.arg.queue,
        changes: {
          open: action.meta.arg.open,
        },
      });
    },
    [setQueueOpen.fulfilled.type]: (state, action) => {
      queuesAdapter.upsertMany(state, action.payload.queues);
    },
    [clearQueue.pending.type]: (state, action) => {
      queuesAdapter.updateOne(state, {
        id: action.meta.arg.queue,
        changes: {
          positions: [],
        },
      });
    },
    [clearQueue.fulfilled.type]: (state, action) => {
      queuesAdapter.upsertMany(state, action.payload.queues);
    },
  },
});

export const { selectById: selectQueueById } = queuesAdapter.getSelectors();

export const selectPositions = (
  state: AppState,
  queue: string,
  status: Position['status'],
): Position[] =>
  state.queues.entities[queue]?.positions.reduce((acc, id) => {
    const position = state.positions.entities[id];
    if (position?.status === status) {
      acc.push(position);
    }
    return acc;
  }, [] as Position[]) ?? [];

export const selectPendingPositions = (state: AppState, queue: string) =>
  selectPositions(state, queue, 'pending');

export const selectFulfilledPositions = (state: AppState, queue: string) =>
  selectPositions(state, queue, 'fulfilled');

export default queues.reducer;
